import React, { useState, useEffect } from "react";
import "../styles/PatientCard.css";
import { SERVER_URL } from "../config";

interface PatientIDVerification {
  verified: boolean;
  idImageUrl?: string; // S3 key for the ID image
  selfieImageUrl?: string; // S3 key for the selfie image
  similarity?: string;
}

interface PatientIDVerificationDisplayProps {
  verification: PatientIDVerification;
}

const PatientIDVerificationDisplay: React.FC<
  PatientIDVerificationDisplayProps
> = ({ verification }) => {
  const [idUrl, setIdUrl] = useState<string | null>(null);
  const [selfieUrl, setSelfieUrl] = useState<string | null>(null);
  console.log({ verification });
  useEffect(() => {
    async function fetchUrl(key: string, setter: (url: string) => void) {
      try {
        const response = await fetch(
          `${SERVER_URL}/api/verify-id/presigned-view-url?key=${encodeURIComponent(
            key
          )}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setter(data.url);
        } else {
          console.error("Failed to fetch presigned URL for key:", key);
        }
      } catch (error) {
        console.error("Error fetching presigned URL for key:", key, error);
      }
    }

    if (verification.idImageUrl) {
      fetchUrl(verification.idImageUrl, setIdUrl);
    }
    if (verification.selfieImageUrl) {
      fetchUrl(verification.selfieImageUrl, setSelfieUrl);
    }
  }, [verification.idImageUrl, verification.selfieImageUrl]);

  return (
    <div className="id-verification-card">
      <h2>ID Verification</h2>
      {verification.verified ? (
        <>
          <p className="verified-status">
            Verified{" "}
            {verification.similarity
              ? `(${verification.similarity}% match)`
              : ""}
          </p>
          <div className="verified-images-box">
            <div className="verification-images">
              {idUrl && (
                <div className="image-container">
                  <p>ID Card</p>
                  <img src={idUrl} alt="ID Card" />
                </div>
              )}
              {selfieUrl && (
                <div className="image-container">
                  <p>Selfie</p>
                  <img src={selfieUrl} alt="Selfie" />
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <p className="not-verified-status">Not Verified</p>
      )}
    </div>
  );
};

export default PatientIDVerificationDisplay;
